import React, { useState, useEffect, useRef } from 'react';

import classNames from 'classnames';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
//import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { FilterMatchMode, FilterOperator } from 'primereact/api';

import { TriStateCheckbox } from 'primereact/tristatecheckbox';
import { Skeleton } from 'primereact/skeleton';
//import { RadioButton } from 'primereact/radiobutton';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { MultiSelect } from 'primereact/multiselect';
import { SelectButton } from 'primereact/selectbutton';
import { ColorPicker } from 'primereact/colorpicker';
import { Tag } from 'primereact/tag';

import Link from 'next/link';

import { GenericaSistemaService } from '../../service/GenericaSistemaService';
import { PlantillaService } from '../../service/PlantillaService';

import AuthStorage from '../../storage/AuthStorage';
import { locale, addLocale } from 'primereact/api';
import lodash from "lodash";

const DataTableListGenericaRaw = React.forwardRef((props, ref) => {
    console.log("DataTableListGenericaRaw");
    //= (props) => {

    //console.log("DataTableGenerica, ");

    const dtTableRaw = useRef(null);

    const codModulo = "DATATABLE_GENERICA";
    const _ = lodash;

    const plantillaService = new PlantillaService();
    const genericaSistemaService = new GenericaSistemaService();

    const authStorage = new AuthStorage(window.location.pathname);
    const userDetails = authStorage.GetCurrentUser();

    const { userName, idEmpresa, idioma, sessionGUID } = userDetails;

    const [etiquetasModulo, setEtiquetasModulo] = useState([]);

    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);

    const [selectedTipoGenerica, setSelectedTipoGenerica] = useState(undefined);
    const [selectedGenericasSistema, setSelectedGenericasSistema] = useState(null);

    const [metadataGenericaSistema, setMetadataGenericaSistema] = useState([]);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [metadataGenericaSistemaRef, setMetadataGenericaSistemaRef] = useState([]);

    let emptyGenericaSistemaInit = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", uts: []
    };

    const [genericaSistema, setGenericaSistema] = useState(emptyGenericaSistemaInit);
    const [selectAll, setSelectAll] = useState(false);

    const [genericasSistema, setGenericasSistema] = useState(null);

    const lazyParamInit = {
        first: 0,
        rows: 5,
        page: 0,
        sortField: null,
        sortOrder: null,
        iteracion: 0,
        filters: {
            'name': { value: '', matchMode: FilterMatchMode.CONTAINS },
        }
    };
    const [lazyParams, setLazyParams] = useState(undefined);

    const lazyParamsInitSelected = useRef(Object.assign({}, lazyParamInit));
    const [comodin, setComodin] = useState(0);

    addLocale('es', {
        startsWith: 'Inicia con',
        contains: 'Contiene',
        notContains: 'No contiene',
        endsWith: 'Termina en',
        equals: 'Igual',
        notEquals: 'Diferente',
        noFilter: 'Sin filtro',
        filter: 'Filtro',
        lt: 'Menor que',
        lte: 'Menor o igual a',
        gt: 'Mayor que',
        gte: 'Mayor o igual a',
        dateIs: 'Fecha es',
        dateIsNot: 'Fecha no es',
        dateBefore: 'Fecha es anterior',
        dateAfter: 'Fecha es posterior',
        custom: 'Persolizados',
        clear: 'Limpiar',
        close: 'Cerrar',
        apply: 'Aplicar',
        matchAll: 'Coinciden todos',
        matchAny: 'Coincide alguno',
        addRule: 'Agregar regla',
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Limpiar'
    });

    locale('es');


    function GetTextoEtiqueta(etiqueta) {
        return (etiquetasModulo.filter(et => et.etiqueta === etiqueta).map(et => et.ctiTexto)[0]);
    }

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }

    useEffect(() => {
        if (props.etiquetasModulo === undefined || props.etiquetasModulo === null || props.etiquetasModulo.length === 0)
            LoadEtiquetas();

    }, [])

    const LoadEtiquetas = async => {

        plantillaService.getEtiquetasModulo(codModulo, idEmpresa, idioma, userName).then(data => {
            setEtiquetasModulo(data);
        });

    }

    if ((props.selectedTipoGenerica !== undefined && selectedTipoGenerica === undefined) || props.selectedTipoGenerica.tg !== selectedTipoGenerica.tg) {
        setSelectedTipoGenerica({ ...props.selectedTipoGenerica });
        setMetadataGenericaSistema([...props.metadataRef]);
        setGenericasSistema([...props.genericasSistema]);
        let camposProyecados = props.camposAMostrar.split(',');
        //let newSelectedColumns = [...props.metadataRef.filter(et => et.ctiConfigurado >= 0 && et.esImprimible > 0 && camposProyecados.some(y => y=== et.campo))];
        let newSelectedColumns = [...camposProyecados.map(y => props.metadataRef.find(met => y === met.campo && met.ctiConfigurado >= 0 && met.esImprimible > 0)).filter(x => x !== undefined)];
        setSelectedColumns(newSelectedColumns)
    }
    else {

        let newSelectedTipoGenerica = undefined;

        if (!_.isEqual(props.selectedTipoGenerica.filtroUts, selectedTipoGenerica.filtroUts)) {
            //else if (props.selectedTipoGenerica.filtroUts !== selectedTipoGenerica.filtroUts) {
            newSelectedTipoGenerica = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version, filtroUts: { ...props.selectedTipoGenerica.filtroUts } };
            setSelectedTipoGenerica(newSelectedTipoGenerica);
            setMetadataGenericaSistema([...props.metadataRef]);
            setGenericasSistema([...props.genericasSistema]);

            let newSelectedColumns2 = [...props.metadataRef.filter(et => et.ctiConfigurado >= 0 && et.esImprimible > 0 && props.camposAMostrar.includes(et.campo))];
            setSelectedColumns(newSelectedColumns2);

        }
        else if (props.selectedTipoGenerica.version !== undefined && selectedTipoGenerica.version !== undefined && props.selectedTipoGenerica.version !== selectedTipoGenerica.version) {

            let newSelectedTipoGenerica2 = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version };
            setSelectedTipoGenerica(newSelectedTipoGenerica2);
            setMetadataGenericaSistema([...props.metadataRef]);
            setGenericasSistema([...props.genericasSistema]);
            setSelectedColumns([...props.metadataRef.filter(et => et.ctiConfigurado >= 0 && et.esImprimible > 0 && props.camposAMostrar.includes(et.campo))])
        }

    }

    /*
    useEffect(() => {
        console.log("entró useEffect", selectedTipoGenerica);
        let tg = selectedTipoGenerica.tg === undefined ? "" : selectedTipoGenerica.tg;

        if (tg !== "") {
            LoadDatosGenerica(tg, idEmpresa, idioma, userName);
        }

    }, [selectedTipoGenerica])
    */

    const LoadDatosGenerica = async (tg, idEmpresa, idioma, userName) => {

        lazyParamInit.filters = createHeaderGenerica([{ "campo": "" }]);

        setSelectedGenericasSistema(null);

        await genericaSistemaService.getMetadataGenericasSistema(tg, idEmpresa, idioma, userName).then(data => {

            let columnaIdentificadorOculta = "tg";
            let prefijo = '000000';
            let TamSufijo = 4;

            if (data.length > 0 && data[0].orden !== undefined) {

                data = data.sort(function (a, b) {
                    let a1 = (prefijo + a.orden).substring((prefijo + a.orden).length - TamSufijo) + '-' + a.campoOrigen + '-' + a.tipoDato;
                    let b1 = (prefijo + b.orden).substring((prefijo + b.orden).length - TamSufijo) + '-' + b.campoOrigen + '-' + b.tipoDato;
                    return a1 > b1 ? 1 : a1 < b1 ? -1 : 0;
                });
            }

            data = data.map(x => ({ ...x, columnRef: null }));

            if (props.metadataRef.refCampoTg !== undefined) {
                let metadataCampoTg = data.find(col => col.campo === props.metadataRef.refCampoTg);
                let newMetadataCampoTg = { ...metadataCampoTg };
                newMetadataCampoTg.ctiTexto = "Cód.";

                const index = data.indexOf(metadataCampoTg);
                data.splice(index, 1, newMetadataCampoTg);

            }

            let metadataImprimible = data.filter(col => col.ctiConfigurado >= 0 && col.esImprimible > 0);
            console.log("metadataImprimible, ", metadataImprimible, "metadataRef, ", props.metadataRef)

            let columnsDefault = []

            if (props.metadataRef !== undefined && props.metadataRef.camposFiltroRef !== undefined && props.metadataRef.camposFiltroRef !== null && props.metadataRef.camposFiltroRef !== "") {
                columnsDefault = props.metadataRef.camposFiltroRef.replace(' ', '').split(',');
            }
            else {
                columnsDefault = [props.metadataRef.refCampoTg, "ctiTexto"]
            }

            //console.log("columnsDefault, ",columnsDefault);

            let newSelectedColumns = metadataImprimible.filter(col => columnsDefault.includes(col.campo))


            let dataRef = data.map(x => ({ campo: x.campo, tipoDato: x.tipoDato, tg: x.tg, columnFiltroRef: null }));

            //let dataForm = metadataImprimible.map(x=> ({...x, formRef : null, mensajeError : ""}));



            //let newSelectedColumns=metadataImprimible.filter(col => col.campo!==columnaIdentificadorOculta )

            if (dataRef.length > 0) {

                //setSelectedColumns([]);

                lazyParamInit.filters = createHeaderGenerica(metadataImprimible);
                let newLazyParamInit = Object.assign({}, lazyParamInit);

                setMetadataGenericaSistema(data);
                setLazyParams(newLazyParamInit);
                lazyParamsInitSelected.current = newLazyParamInit;
                setSelectedColumns(newSelectedColumns);
                console.log("data, ", data, ", newLazyParamInit, ", newLazyParamInit, ", newSelectedColumns, ", newSelectedColumns);
            }

        });

    }

    const onBooleanChange = (e, campo) => {

        const val = (e.checked && e.checked) || false;

        let _genericaSistema = { ...genericaSistema };

        if (metadataGenericaSistema.find(x => x.campo === campo))
            _genericaSistema['uts'][`${campo}`] = val;
        else
            _genericaSistema[`${campo}`] = val;

        setGenericaSistema(_genericaSistema);

    }

    const onInputChange = (e, campo) => {


        const val = (e.target && e.target.value) || '';
        let _genericaSistema = { ...genericaSistema };

        if (metadataGenericaSistema.find(x => x.campo === campo))
            _genericaSistema['uts'][`${campo}`] = val;
        else
            _genericaSistema[`${campo}`] = val;

        setGenericaSistema(_genericaSistema);
    }

    const onInputNumberChange = (e, campo) => {
        const val = e.value || 0;

        let _genericaSistema = { ...genericaSistema };

        if (metadataGenericaSistema.find(x => x.campo === campo))
            _genericaSistema['uts'][`${campo}`] = val;
        else
            _genericaSistema[`${campo}`] = val;

        setGenericaSistema(_genericaSistema);

    }

    const onSelectionChange = (event) => {
        const value = event.value;
        if (props.onSelectedItem)
            props.onSelectedItem(value, props.metadataRef);
    }

    /*
    useEffect(() => {

        if (lazyParams !== undefined && selectedTipoGenerica !== undefined) {
            //console.log("llamó hpe,",selectedTipoGenerica, lazyParams);
            loadLazyData();
        }

    }, [lazyParams]) // eslint-disable-line react-hooks/exhaustive-deps
*/

    const loadLazyData = () => {
        setLoading(true);

        if (selectedTipoGenerica.tg !== undefined && selectedTipoGenerica.tg !== "") {
            genericaSistemaService.GetAllGenericasSistemaDependiente(selectedTipoGenerica.tg, props.metadataRef.tg, props.metadataRef.referenciaRef, { lazyEvent: JSON.stringify(lazyParams) }, idEmpresa, idioma, userName).then(data => {
                //setMetadataGenericaSistema(data.metadata);
                setGenericasSistema(data.data)
                setTotalRecords(previo => previo < 0 ? data.totalRecord : data.totalRecord);
                setLoading(false);
            });

        }
        else {
            setGenericasSistema([])
            setTotalRecords(0);
            setLoading(false);
        }

    }

    const onPage = (event) => {
        setLazyParams(event);
    }

    const onSort = (event) => {
        setLazyParams(event);
    }

    const onFilter = (event) => {
        event['first'] = 0;
        setLazyParams(event);
    }

    const ColumnFilterTemplate = (options) => {


        //const campo =  selectedColumns.find(et => et.campo ===options.field);
        //const metadataRef =  metadataGenericaSistemaRef.find(et => et.campo ===options.field);
        const metadata = metadataGenericaSistema.find(et => et.campo === options.field);
        const metaColumn = selectedColumns.find(et => et.campo === options.field);

        const lazyParamCampo = Object.keys(lazyParams.filters).includes(options.field) ? lazyParams.filters[`${metadata.campo}`] : null;
        const val = lazyParamCampo !== null ? lazyParamCampo.value : "";

        switch (metadata.tipoDato) {
            case "boolean": return <TriStateCheckbox id={`filter${metadata.tg + '-' + metadata.campo}`} value={options.value} onChange={(e) => options.filterCallback(e.value)} />; break;
            //case "int": return ( <InputNumber id = {`filter${metadata.tg+'-'+metadata.campo}`} placeholder="Search..."  style={{ paddingLeft: '0.5rem', 'minWidth': '5rem' }} onValueChange={(e) => onfilterapply(options, e) }  />); break;
            //case "double": return ( <InputNumber id = {`filter${metadata.tg+'-'+metadata.campo}`} placeholder="Search..." mode="decimal" style={{ paddingLeft: '0.5rem', 'minWidth': '5rem' }} onValueChange={(e) => onfilterapply(options, e) }  />); break;
            default: return (<InputText id={`filter${metadata.tg + '-' + metadata.campo}`} ref={e => metaColumn.columnRef = e} placeholder="Search..." type="search" style={{ paddingLeft: '0.5rem', minWidth: '5rem' }} onKeyDown={(e) => { if (e.key === 'Enter') { onfilterapply(options, e) } }} />); break;
        }

    }

    const onfilterapply = (options, event) => {
        options.filterApplyCallback(event.target.value);
    }

    const colorBodyTemplate = (rowData, column) => {

        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = "";
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return <ColorPicker disabled value={val} />;
    }

    function isValidColor(strColor) {
        var s = new Option().style;
        s.color = strColor;

        // return 'false' if color wasn't assigned
        return s.color === strColor.toLowerCase();
    }

    const columnBodyTemplate = (tipoDato, formatoDato) => {

        if (selectedTipoGenerica.tg === "ACA_VSTA_MATRICULADOS_DETALLE_PARA_DIGITACION_NOTA" && formatoDato === "ACA_UNIDAD_RA_CRITERIO_NIVEL") {
            return selectButtonBodyTemplate;
        }


        switch (tipoDato) {
            case 'boolean':
                return booleanBodyTemplate

            case 'double':
                return doubleBodyTemplate
            case 'int':
                return formatoDato === "money" ? moneyBodyTemplate : intBodyTemplate
            case 'money':
                return moneyBodyTemplate
            case 'tags':
                return tagsBodyTemplate
            case 'text':
                return textRichBodyTemplate
            case 'date':
                return dateBodyTemplate
            case 'color':
                return colorBodyTemplate
            case 'file':
                return fileBodyTemplate
            default:
                {
                    if (tipoDato === 'ref' && formatoDato === 'ACA_UNIDAD_RA_CRITERIO_NIVEL') return selectButtonBodyTemplate;
                    else
                        return textRichBodyTemplate
                    //return textBodyTemplate;
                }
        }
    }

    const tagsBodyTemplate = (rowData, column) => {

        let tagsString = rowData.uts[column.field];

        if (tagsString !== undefined && tagsString !== "") {

            let tags = JSON.parse('' + tagsString + '');

            if (tags !== null) {
                return (



                    tags.map(x =>
                        <Tag key={0} rounded style={{ backgroundColor: isValidColor(x.color) ? x.color : "#" + x.color }} value={x.ctiTexto}>
                        </Tag>

                    )




                );

            }
            else {
                return (<></>);
            }



        }
        else
            return (<></>);


    }

    const booleanBodyTemplate = (rowData, column) => {
        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = false;
        if (metadata) {
            val = (typeof rowData.uts[column.field] === "boolean") ? rowData.uts[column.field] : typeof rowData.uts[column.field] === "string" ? rowData.uts[column.field].toLowerCase() === "true" : false;
        }

        return <i className={classNames('pi', val === true ? 'true-icon pi-check-circle' : 'false-icon pi-times-circle')}></i>;
        //return (<Checkbox checked={val} readOnly className='surface-300' ></Checkbox>);
    }

    const doubleBodyTemplate = (rowData, column) => {
        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = false;
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return <span >{val.toFixed(2)}</span>;
    }

    const intBodyTemplate = (rowData, column) => {
        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = false;
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return <span >{Math.trunc(val)}</span>;
    }

    const moneyBodyTemplate = (rowData, column) => {
        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = false;
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return <span >{val.toLocaleString('es-CO', { style: 'currency', currency: 'COP' })}</span>;
    }

    const textBodyTemplate = (rowData, column) => {

        let val = "";
        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        if (metadata) {
            val = rowData.uts[column.field];
        }

        let valTexto = "";
        if (metadata) {
            valTexto = rowData.uts[column.field];
        }
        //let tamMaximoVisibleFila = 100;
        //let mostrarBoton = (valTexto !== undefined && valTexto !== null && valTexto !== "" && valTexto.length > tamMaximoVisibleFila);
        //val = mostrarBoton ? valTexto.substring(0, tamMaximoVisibleFila) + "[...]" : valTexto;

        return (
            <span style={{ maxWidth: "5rem", wordBreak: "break-word" }} >{valTexto}</span>
        );

    }

    const textRichBodyTemplate = (rowData, column) => {

        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let valTexto = "";
        if (metadata) {
            valTexto = rowData.uts[column.field];
        }
        //let tamMaximoVisibleFila = 100;
        //let mostrarBoton = (valTexto !== undefined && valTexto !== null && valTexto !== "" && valTexto.length > tamMaximoVisibleFila);
        //let val = mostrarBoton ? valTexto.substring(0, tamMaximoVisibleFila) + "[...]" : valTexto;

        return (
            <div style={{ wordBreak: "break-word", color: "black" }} dangerouslySetInnerHTML={{ __html: valTexto }} />
        );
    }

    const fileBodyTemplate = (rowData, column) => {

        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let valRefDoc = "";
        if (metadata) {
            valRefDoc = rowData.uts[column.field];
        }

        if ((valRefDoc !== null && valRefDoc !== undefined && valRefDoc !== ""))
            return (<Link target="_blank" icon="pi pi-download" rel="noopener noreferrer" href={"file?guid=" + valRefDoc}>Archivo</Link>);
        else
            return <span>No presenta adjunto</span>
    }

    const dateBodyTemplate = (rowData, column) => {

        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = "";
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return <span >{val.toLocaleDateString() + " " + val.toLocaleTimeString()}</span>;
    }

    const selectButtonBodyTemplate = (rowData, column) => {
        let items = [];

        let campoCtiTextocriterio = 'ctiTextonivelDesempenoRA';
        let campoOptionsSelectButton = 'nivelDesempenoRA';
        let campoCtiTextoOptionsSelectButton = 'ctiTextonivelDesempenoRA';

        let campoCriterio = 'criterioRA';
        let valCriterio = rowData.uts[campoCriterio];

        let valBase = rowData.uts[column.field];

        //items = optionsSelectButton.filter(x => x.tg === "ACA_UNIDAD_RA_CRITERIO_NIVEL" && x.uts['criterioRA'] === criterioRA).map(x => ({ value: x.uts[''], 'name': x.uts['ctiTextonivelDesempenoRA'] }));
        //items = optionsSelectButton.filter(x => x.tg === "ACA_UNIDAD_RA_CRITERIO_NIVEL" && x.uts[campoCriterio] === valCriterio).map(x => ({ value: x.uts[campoOptionsSelectButton], 'name': x.uts[campoCtiTextoOptionsSelectButton] }));

        //console.log("valBase, ", valBase);
        //console.log("optionsSelectButton, ", optionsSelectButton);
        //console.log("items, ", items);

        return (
            <SelectButton value={valBase} optionLabel="name" options={items} readOnly={true} />
        );

    };


    const ConvertTipoDatoADateTypeTabla = (tipoDato) => {

        let res = "text";

        switch (tipoDato) {
            case "date": res = "date"; break;
            case "int": res = "numeric"; break;
            case "double": res = "numeric"; break;
            case "boolean": res = "boolean"; break;
            default: res = "text"; break;
        }

        return res;
    }



    //return <Column key={k.campo}  field={k.campo} header={ k.ctiTexto } sortable filter filterPlaceholder="Buscar por xyz" />;
    const columnsDataTable = selectedColumns.filter(x => x.campo !== props.groupRowsBy).map(k => {
        return <Column key={k.campo} field={k.campo} header={k.ctiTexto} //dataType={ConvertTipoDatoADateTypeTabla(k.tipoDato)}
            body={columnBodyTemplate(k.tipoDato, k.formatoDato)}

        //filter filterElement={k.tipoDato === "boolean" ? booleanRowFilterTemplate : textRowFilterTemplate} 
        //filter filterElement={ColumnFilterTemplate}
        //filterPlaceholder="Buscar por xyz" 
        />;
    });

    const clearFilter1 = () => {
        initFilters1();
    }

    const aplicarFiltro = () => {
        buscarFilter1();
    }

    const onColumnToggle = (event) => {

        let newselectedColumns = event.value;

        let orderedSelectedColumns = metadataGenericaSistema.filter(col => newselectedColumns.some(sCol => sCol.campo === col.campo && col.ctiConfigurado >= 0 && col.esImprimible > 0));

        setSelectedColumns(orderedSelectedColumns);
    }

    const header = (
        <div className="">

            <h5 className="m-0">{GetTextoEtiqueta("LABEL_MANAGE")} - {selectedTipoGenerica !== undefined && selectedTipoGenerica.ctiTexto ? selectedTipoGenerica.ctiTexto : ""}</h5>

            <div className="flex flex-row-reverse flex-wrap card-container yellow-container">
                <span className="block mt-2 md:mt-0 p-input-icon-left">
                    <i className="pi pi-search" />

                    <MultiSelect value={selectedColumns}
                        options={metadataGenericaSistema.filter(col => col.ctiConfigurado >= 0 && col.esImprimible > 0)}
                        optionLabel="ctiTexto" onChange={onColumnToggle} style={{ with: '10em' }} />

                </span>

            </div>
        </div>

    );





    const createHeaderGenerica = (objecto) => {

        let headers = "";

        //Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&')

        objecto.forEach(function (meta, indice, array) {
            if (indice > 0) {
                headers += ',';
            }
            else {
                headers += '{';
            }

            switch (meta.tipoDato) {
                case "int": headers += `"${meta.campo}":{ "value": "", "matchMode": "equals", "ref": null }`; break;
                case "double": headers += `"${meta.campo}":{ "value": "", "matchMode": "equals", "ref": null }`; break;
                case "money": headers += `"${meta.campo}":{ "value": "", "matchMode": "equals", "ref": null }`; break;
                case "date": headers += `"${meta.campo}":{ "value": "", "matchMode": "equals", "ref": null }`; break;
                case "string": headers += `"${meta.campo}":{ "value": "", "matchMode": "contains", "ref": null }`; break;
                default: headers += `"${meta.campo}":{ "value": "", "matchMode": "contains","ref": null }`; break;
            }

        });

        headers += '}';

        return (JSON.parse('' + headers + ''));
    }


    const initFilters1 = () => {
        setLazyParams(Object.assign({}, lazyParamsInitSelected.current));
        //setGlobalFilterValue2('');
    }

    const buscarFilter1 = () => {
        setLazyParams(Object.assign({}, lazyParams));
        //setGlobalFilterValue2('');
    }

    const arrayTemplate = Array.from({ length: 5 });
    const bodyTemplate = () => {
        return <Skeleton></Skeleton>
    }

    const headerGroupRowTemplate = (data) => {
        //console.log("headerGroupRowTemplate", dt.current.groupRowsBy, data);
        return (
            <div className="informacion-general flex align-items-center gap-2">
                <span className="font-bold">{data.uts[props.groupRowsBy]}</span>
            </div>
        );
    };

    const footerGroupRowTemplate = (data) => {
        return (
            <></>
        );
    };

    //console.log("selectedTipoGenerica, ",selectedTipoGenerica, "metadataGenericaSistema, ",metadataGenericaSistema, "genericasSistema, ", genericasSistema, "selectedColumns, ", selectedColumns);

    if (//lazyParams === undefined || 
        selectedTipoGenerica === undefined || !selectedTipoGenerica.tg || !selectedTipoGenerica.tg === ""
        || metadataGenericaSistema.length == 0 || selectedColumns.length == 0 || props.genericasSistema === undefined  // || genericasSistema === undefined
    ) {

        return (<DataTable value={arrayTemplate} className="p-datatable-striped" header={bodyTemplate}>
            <Column field="code" header="Code" style={{ width: '25%' }} body={bodyTemplate}></Column>
            <Column field="name" header="Name" style={{ width: '25%' }} body={bodyTemplate} ></Column>
        </DataTable>)
    }

    else {
        //console.log("dfdfdf", `uts.${props.groupRowsBy}`, genericasSistema[0]);
        return (
            <DataTable lazy value={props.genericasSistema} size="small"
                dataKey="indexRow" ref={dtTableRaw} style={{ width: '100%', height: '100%' }}
                rowGroupMode={props.groupRowsBy !== undefined && props.groupRowsBy !== "" ? "subheader" : ""} sortMode="single" sortField={props.groupRowsBy !== undefined && props.groupRowsBy !== "" ? `uts.${props.groupRowsBy}` : ""}
                groupRowsBy={`uts.${props.groupRowsBy}`} rowGroupHeaderTemplate={props.groupRowsBy !== undefined && props.groupRowsBy !== "" ? headerGroupRowTemplate : undefined}
                rowGroupFooterTemplate={props.groupRowsBy !== undefined && props.groupRowsBy !== "" ? footerGroupRowTemplate : undefined}
                //paginator first={lazyParams.first} rows={lazyParams.rows} totalRecords={totalRecords} rowsPerPageOptions={[5, 10, 25]} onPage={onPage} 
                //filterDisplay="row" onFilter={onFilter} filters={lazyParams.filters} loading={loading}
                //onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                //onSelectionChange={onSelectionChange}  selectionMode="single"
                //resizableColumns
                //selection={selectedGenericasSistema} 
                //selectAll={selectAll} 
                //onSelectAllChange={onSelectAllChange}
                //globalFilter={globalFilter} 
                emptyMessage="No se encontraron datos" //{GetTextoEtiqueta("LABEL_EMPTY_MESSAGE")}
                //className={"datatable-responsive"+" "+props.className}
                responsiveLayout="scroll"
            //paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            //currentPageReportTemplate="{first} to {last} of {totalRecords}"
            >
                {columnsDataTable}

            </DataTable>
        );
    }

});

/*const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(DataTableGenerica, comparisonFn);*/
export default DataTableListGenericaRaw;

